import React, { useContext } from 'react'
import { Text } from "@react-three/drei";
import { GVarState } from '../StoreState/Gstate';
import { ShowTextWhat } from '../Action/Action';

let Text3d = (props) => {
  let g = useContext(GVarState);
  let { LocationName, point, childStore } = props
  return (
    <Text depthTest={true} material-toneMapped={true}
      position={[
        LocationName.area.x / 10,
        LocationName.area.y / 10,
        -0.3,
      ]}
      fontSize={LocationName.textSize / 10}
      color={LocationName.threeTextColor || LocationName.textColor}
      rotation={[-Math.PI / 1, 0, -Math.PI / 180 * LocationName.rotate]}
      overflowWrap={"break-word"}
      anchorX="left"
      anchorY="top"
      maxWidth={LocationName.width ? LocationName.width / 10 : 100}
    >
      {childStore?.name ||  LocationName.text}
    </Text>
  )
}

export default Text3d